import React, { lazy, Suspense, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useLocation,
} from 'react-router-dom';

import { AuthRoute, PrivateRoute, CircularProgress } from './components';
import { PATHS } from '../constants/paths';
import { useInitializeLoginByLocaStorage } from './hooks/useInitializeLoginByLocaStorage';
import { useLoadGoogleApis } from './hooks/useLoadGoogleApis';
import { useGeolocation } from './hooks/useGeolocation';
// import { useLoadGoogleAnalitycs } from './hooks/useLoadGoogleAnalitycs';
import { useLoadGoogleTagManager } from './hooks/useLoadGoogleTagManager';
import { useLoadFacebookPixel } from './hooks/useLoadFacebookPixel';

// const HomePage = lazy(() => import('./modules/Home'));
// const LoginPage = lazy(() => import('./modules/Auth/pages/Login'));
// const RegistrationPage = lazy(() =>
//   import('./modules/Auth/pages/Registration'),
// );
const SharedAuthPage = lazy(() => import('./modules/Auth/pages/SharedAuth'));
const CashInPage = lazy(() => import('./modules/CashIn'));
const CashOutPage = lazy(() => import('./modules/CashOut'));
const PaymentsPage = lazy(() => import('./modules/Payments'));
const WalletPage = lazy(() => import('./modules/Wallet'));
// const LiquidationsPage = lazy(() => import('./modules/Liquidations'));
// const LiquidationRequestPage = lazy(() =>
//   import('./modules/LiquidationRequest'),
// );
const MovementsPage = lazy(() => import('./modules/Movements'));
const ProfilePage = lazy(() => import('./modules/Profile'));
const ReportsPage = lazy(() => import('./modules/Reports'));
const ReportsHistoryPage = lazy(() => import('./modules/ReportsHistory'));
const AboutUsPage = lazy(() => import('./modules/AboutUs'));
const ContactPage = lazy(() => import('./modules/Contact'));
// const TermsAndConditionsPage = lazy(() =>
//   import('./modules/TermsAndConditions'),
// );
// const PrivacyPolicyPage = lazy(() => import('./modules/PrivacyPolicy'));
const FrequentQuestionsPage = lazy(() => import('./modules/FrequentQuestions'));
const ConfirmationPage = lazy(() => import('./modules/Confirm'));
const Recovery = lazy(() => import('./modules/Recovery'));
const ChangePasswor = lazy(() => import('./modules/ChangePassword'));

const NotFound = () => {
  const location = useLocation();

  // eslint-disable-next-line no-console
  console.log('NotFound', 'location', location);

  return <h1>No found</h1>;
};

const ExternalRedirect = ({ path }) => {
  useEffect(() => {
    window.location.href = path;
  }, [path]);

  return null;
};

const App = () => {
  useInitializeLoginByLocaStorage();
  useGeolocation();
  useLoadGoogleApis('AIzaSyAxqQ7cPNV125lvIrUKdVvpN0GSG_hGgNU');
  // useLoadGoogleAnalitycs('G-KSXL568Z5Q');
  useLoadGoogleTagManager('GTM-MSFBW8HX');
  useLoadFacebookPixel('667045987921454');

  return (
    <Router basename="/comercios">
      <Suspense fallback={<CircularProgress style={{ height: '100vh' }} />}>
        <Switch>
          <PrivateRoute exact path={PATHS.home.path} component={WalletPage} />
          <Route
            exact
            path={PATHS.login.localPath}
            component={() => <ExternalRedirect path={PATHS.login.path} />}
          />
          <Route path={PATHS.sharedAuth.path} component={SharedAuthPage} />
          <AuthRoute
            exact
            path={PATHS.registration.localPath}
            component={() => (
              <ExternalRedirect path={PATHS.registration.path} />
            )}
          />
          <PrivateRoute path={PATHS.cashIn.path} component={CashInPage} />
          <PrivateRoute path={PATHS.cashOut.path} component={CashOutPage} />
          <PrivateRoute path={PATHS.payments.path} component={PaymentsPage} />
          {/* <PrivateRoute path={PATHS.wallet.path} component={WalletPage} exact /> */}
          {/* <PrivateRoute
            path={PATHS.liquidations.path}
            component={LiquidationsPage}
            exact
          /> */}
          {/* <PrivateRoute
            path={PATHS.liquidationRequest.path}
            component={LiquidationRequestPage}
            exact
          /> */}
          <PrivateRoute
            path={PATHS.movements.path}
            component={MovementsPage}
            exact
          />

          <PrivateRoute path={PATHS.profile.path} component={ProfilePage} />
          <PrivateRoute
            path={PATHS.reports.path}
            component={ReportsPage}
            exact
          />
          <PrivateRoute
            path={PATHS.reportsHistory.path}
            component={ReportsHistoryPage}
            exact
          />

          <Route path={PATHS.aboutUs.path} component={AboutUsPage} />
          <Route path={PATHS.contact.path} component={ContactPage} />
          <Route
            exact
            path={PATHS.termsAndConditions.localPath}
            component={() => (
              <ExternalRedirect path={PATHS.termsAndConditions.path} />
            )}
          />
          <Route
            exact
            path={PATHS.privacyPolicy.localPath}
            component={() => (
              <ExternalRedirect path={PATHS.privacyPolicy.path} />
            )}
          />
          <Route
            path={PATHS.frequentQuestions.path}
            component={FrequentQuestionsPage}
          />
          <Route path={PATHS.confirmation.path} component={ConfirmationPage} />
          <Route path={PATHS.passwordRecovery.path} component={Recovery} />
          <Route path={PATHS.ChangePasswor.path} component={ChangePasswor} />
          <Route path="*" component={NotFound} />
        </Switch>
      </Suspense>
    </Router>
  );
};

export default App;
